import apiClient from '../utils/apiClient';

/**
 * #112630 (BA-3) — phản ánh khách kèm nhân viên đã pha món.
 * Chỉ ĐỌC: màn này để quản lý phát hiện ai bị phản ánh lặp lại mà cần đào tạo lại.
 */
export const customerFeedbackAPI = {
  /** Danh sách phản ánh gần đây (lọc chi nhánh/nhân viên/hạng mục/điểm/ngày) */
  getFeedbacks: async (params = {}) => {
    return await apiClient.get({
      url: '/customer-feedback/admin',
      params,
    });
  },

  /** Đếm số lần bị phản ánh theo từng nhân viên (cùng bộ lọc, trừ lọc nhân viên) */
  getCountByEmployee: async (params = {}) => {
    return await apiClient.get({
      url: '/customer-feedback/admin/by-employee',
      params,
    });
  },
};
